import qs from 'qs';

const buildLeadUrl = (basePath: string, params: Record<string, string | number | null | undefined>) =>
  `${basePath}?${qs.stringify(params, { skipNulls: true })}`;

export default buildLeadUrl;
